import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';

import ContentCrateLoading from 'shared/app/components/content-crate-loading';
import { menuIsLoadingSelector } from 'shared/app/bundles/menu';
import { usePdpContext } from 'ordering/app/components/product-details-page/pdp-provider';

import OptionPickerByFormCode from '../product-options-fields/option-picker-by-form-code';
import { filterDeselectedOptions } from '../../pdp-provider/use-clear-deselected-options/clear-deselected-options';

import CallsToAction from './calls-to-action';
import messages from './messages';

export const IncludedSection = () => {
  const { formatMessage } = useIntl();
  const { product, customerRecipe, selectedOptions } = usePdpContext();
  const { error: productError, errorMessage, productOptions } = product || {};
  const menuIsLoading = useSelector(menuIsLoadingSelector);

  if (productError && !menuIsLoading) {
    // wait to display an error until the menu has loaded as the
    // message to show changes based on menu result
    return <p>{formatMessage(errorMessage)}</p>;
  }

  if (!productOptions) {
    return (
      <div>
        <ContentCrateLoading />
      </div>
    );
  }

  const filteredSelectedOptions = filterDeselectedOptions(selectedOptions);

  const headingMessage = filteredSelectedOptions?.length
    ? messages.customizedHeader
    : messages.defaultHeader;

  return (
    <React.Fragment>
      {customerRecipe?.length ? (
        <React.Fragment>
          <Heading
            bottomBorder
            className="mb3 text-semibold"
            data-e2e="included-section-heading"
            size="md"
            tagName="h2"
          >
            {formatMessage(headingMessage)}
          </Heading>
          {customerRecipe.map((option) => {
            const {
              categoryKeyPath,
              deselected,
              formCode,
              topLevelCategoryName,
              topLevelCategoryNumber,
              productNumber,
              productOptionCategory,
              productOption,
            } = option;

            return (
              <OptionPickerByFormCode
                category={productOptionCategory}
                categoryKeyPath={categoryKeyPath}
                formCode={formCode}
                key={`${productNumber}-${formCode}`}
                productOption={productOption}
                topLevelCategoryName={topLevelCategoryName}
                topLevelCategoryNumber={topLevelCategoryNumber}
                useInactiveStyle={deselected}
              />
            );
          })}
        </React.Fragment>
      ) : null}
      <CallsToAction filteredSelectedOptions={filteredSelectedOptions} />
    </React.Fragment>
  );
};

export default IncludedSection;
